import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NRListIcon from '../../NRIcons/NRListIcon';
import { useContext, useState } from 'react';
import NRActivityFeed from './NRActivityFeed';
import { ComponentContext } from '../../ContextWrappers/NRComponentContextWrapper';

function NRViewActivityFeedButton() {
  const { asset } = useContext(ComponentContext);
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleClose = () => {
    setOpenDrawer(false);
  };

  return (
    <Box ml={2} alignSelf="center" mt={'-10px'}>
      <NRActivityFeed asset={asset} openDrawer={openDrawer} handleClose={handleClose} />
      <Button
        sx={{ textTransform: 'unset', fontWeight: 600, whiteSpace: 'nowrap' }}
        disableElevation
        variant="outlined"
        color="secondary"
        startIcon={<NRListIcon fillOpacity="0.6" />}
        onClick={() => setOpenDrawer(true)}
        disabled={!asset}
      >
        View Activity Feed
      </Button>
    </Box>
  );
}
export default NRViewActivityFeedButton;
